import { useUserPermissions } from '../../../pages/company/userPermissions'

export const useCanEditAdGroup = (): boolean => {
  const { edit } = useUserPermissions()
  return edit
}
